import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P22-E1',
    audio: 'img/FriendsPlus/Page22/Audio/audio-e1-p22.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/tieude-e1-p22.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page22/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page22/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/10.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/20.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/30.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/40.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/14.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/50.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/15.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page22/E1/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page22/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/18.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/60.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/20.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/70.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/22.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/80.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/24.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/90.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/25.jpg' },
        { url: 'img/FriendsPlus/Page22/E1/26.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/100.mp3' },
        { url: 'img/FriendsPlus/Page22/E1/27.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page22/E1/28.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P22-E2',
    audio: 'img/FriendsPlus/Page22/Audio/audio-e2-p22.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page22/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page22/Audio/tieude-e2-p22.mp3' },
        { url: 'img/FriendsPlus/Page22/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page22/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P22-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page22/E3/1.jpg' },
      ],
    ],
  },
}

export default json;